import t from 'tcomb';

export const Action = t.interface(
  { type: t.String },
  { name: 'Action', strict: false }
);

export const createReducer = State => t.func([t.maybe(State), Action], State);
